// extracted by mini-css-extract-plugin
module.exports = {"namingForm":"Naming_namingForm__1Ieo6"};